import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME,
  AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME,
} from './constants';
import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT_ROUTE_NAME } from './submodules/tracker-history-changes-edit/constants';
import { AffiliatesApprovedTrackersSettingsTrackerHistoryChangesEditModule } from './submodules/tracker-history-changes-edit/TrackerHistoryChangesEditModule';

export class AffiliatesApprovedTrackersSettingsTrackerDealChangesModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedTrackersSettingsTrackerHistoryChangesEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME,
      path: ':trackerId/conditions',
      component: () => import('./pages/TrackerDealChangesModalPage/TrackerDealChangesModalPage.vue'),
      props: {
        backTo: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME },
        editHistoryRoute: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT_ROUTE_NAME },
        backFromEditHistoryRoute: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME },
        trackersListQueryKey: AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
      },
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
